import { render, staticRenderFns } from "./GamePage.vue?vue&type=template&id=54862f22&scoped=true"
import script from "./GamePage.vue?vue&type=script&lang=js"
export * from "./GamePage.vue?vue&type=script&lang=js"
import style0 from "./GamePage.vue?vue&type=style&index=0&id=54862f22&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54862f22",
  null
  
)

export default component.exports